// extracted by mini-css-extract-plugin
module.exports =  {"mandatory":"SendTestInvitesModal-module_mandatory_ac2d6","backofficeButton":"SendTestInvitesModal-module_backofficeButton_a8174"};